// extracted by mini-css-extract-plugin
var _1 = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol";
var _2 = "_0JAIq__plinko";
var _3 = "_0JAIq__plinkoGrid";
var _4 = "_0JAIq__wrapper";
export { _1 as "font", _2 as "plinko", _3 as "plinkoGrid", _4 as "wrapper" }
